import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertType, OperationalMessage } from '../../../../core/model';
import { FeedSelectors } from '../../../../core/user/store/selectors/user.selectors';
import { StateWithUser } from '../../../../core/user/store/user-state';
import { stringToHash } from '../../../../core/util';
import { AlertsConfig } from '../config/alerts-config';
import { AlertsActions } from '../store/actions';
import { StateWithAlerts } from '../store/alerts-state';
import { AlertsSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  constructor(private store: Store<StateWithAlerts & StateWithUser>, private config: AlertsConfig) {}

  getOperationalMessage(): Observable<OperationalMessage | undefined> {
    return this.store
      .select(FeedSelectors.getFeedOperationalMessageWrapper)
      .pipe(map((operationalMessage) => operationalMessage?.message));
  }

  isAlertDismissed(type: AlertType, body: string = ''): Observable<boolean> {
    return this.store
      .select(AlertsSelectors.getAlertDismissalStateFactory(type, stringToHash(body)))
      .pipe((isDismissed) => isDismissed);
  }

  dismissAlert(type: AlertType, body: string = ''): void {
    const reappearable = this.config.alerts.reappearableAlerts?.includes(type);
    this.store.dispatch(new AlertsActions.DismissAlert({ type, reappearable, messageHash: stringToHash(body) }));
    if (reappearable) {
      this.store.dispatch(new AlertsActions.ClearAlertDelayed({ type }));
    }
  }

  clearAlert(type: AlertType): void {
    this.store.dispatch(new AlertsActions.ClearAlert({ type }));
  }

  clearAllAlerts(): void {
    this.store.dispatch(new AlertsActions.ClearAllAlerts());
  }
}
